"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlyEligibleEssentialsTierWidget = void 0;
var React = require("react");
var commonFunctions_1 = require("../../../commonFunctions");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var AggregatorReferenceWidget_1 = require("../common/AggregatorReferenceWidget");
var modals = require("../motor/tierTable/TierTableInfoModalRenderers");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var core_1 = require("@athena-portal/core");
var FalconAccordion_1 = require("../../../components/FalconAccordion");
var DocumentListModal_1 = require("./DocumentListModal");
var items = function (optionalExtras, protectedNCD) { return [
    { text: "Accidental damage", included: true, info: modals.renderAccidentalDamageModal(), includeModal: false },
    { text: "Fire & theft", included: true, info: modals.renderFireTheftModal(), includeModal: false },
    { text: "Windscreen cover", included: true, info: modals.renderWindscreenCoverModal(), includeModal: false },
    { text: "Personal accident cover (£1,000)", included: true, info: modals.renderNewPersonalAccidentCoverModal(), includeModal: false },
    { text: "Breakdown cover - European (optional)", included: optionalExtras.breakdownCover, info: modals.renderBreakDownCoverModal(), includeModal: true },
    { text: "Protected no claim discount (optional)", included: protectedNCD, info: modals.renderProtectedNoClaimDiscountModal(), includeModal: true },
    { text: "Motor legal expenses (optional)", included: optionalExtras.motorLegalExpenses, info: modals.renderMotorLegalExpensesModal(), includeModal: true },
    { text: "Guaranteed hire car (optional)", included: optionalExtras.courtesyCar, info: modals.renderGuaranteedHireCarModal(), includeModal: true }
]; };
var itemsUnderSpoiler = [
    { text: "Driving other cars", included: false, info: modals.renderDrivingOtherCarsModal(), includeModal: false },
    { text: "European cover for up to 180 days a year (minimum cover needed by law to drive in Europe)", included: true },
    { text: "Child car seat replacement", included: true, info: modals.renderChildCarSeatReplacementModal(), includeModal: false },
    { text: "Manufacturer fitted in car entertainment", included: true },
    { text: "Accident transport", included: true, info: modals.renderAccidentTransportModal(), includeModal: false },
    { text: "Motor trade", included: true, info: modals.renderMotorTradersModal(), includeModal: false },
    { text: "Valet parking", included: true, info: modals.renderValetParkingModal(), includeModal: false },
    { text: "EV battery", included: true, info: modals.renderEVBatteryModal(), includeModal: false },
    { text: "EV cable liability", included: true, info: modals.renderEVCablesLiabilityModal(), includeModal: false },
    { text: "Theft of keys", included: true, info: modals.renderTheftOfCarKeysModal(), includeModal: false },
    { text: "Loss of keys", included: false, info: modals.renderLossOfCarKeysModal(), includeModal: false },
    { text: "Personal belongings", included: false, info: modals.renderPersonalBelongingsModal(), includeModal: false },
    { text: "Misfuelling", included: false, info: modals.renderMisfuellingModal(), includeModal: false },
    { text: "New car replacement", included: false, info: modals.renderNewCarReplacementModal(), includeModal: false },
    { text: "Medical expenses", included: false, info: modals.renderMedicalExpensesModal(), includeModal: false },
    { text: "Uninsured driver promise", included: false, info: modals.renderUninsuredDriverPromiseModal(), includeModal: false },
    { text: "Vandalism promise", included: false, info: modals.renderVandalismPromiseModal(), includeModal: false },
    { text: "Journey continuation and alternative accommodation costs", included: false, info: modals.renderAlternativeTransportCostsModal(), includeModal: false },
    { text: "Car jacking", included: false, info: modals.renderCarJackingModal(), includeModal: false },
    { text: "Road rage", included: false, info: modals.renderRoadRageModal(), includeModal: false },
    { text: "EV cables", included: false, info: modals.renderEVCablesModal(), includeModal: false },
    { text: "EV charge point", included: false, info: modals.renderEVChargePointModal(), includeModal: false },
    { text: "EV recovery to nearest charge point", included: false, info: modals.renderEVRecoveryToNearestChargePointModal(), includeModal: false },
    { text: "EV courtesy car", included: false, info: modals.renderEVCourtesyCarModal(), includeModal: false },
];
var OnlyEligibleEssentialsTierWidget = exports.OnlyEligibleEssentialsTierWidget = /** @class */ (function (_super) {
    __extends(OnlyEligibleEssentialsTierWidget, _super);
    function OnlyEligibleEssentialsTierWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.previousPremium = 0;
        if (_this.props.interaction.product === services_1.PRODUCT_WOLF_MOTOR) {
            _this.previousPremium = _this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL ?
                _this.props.interaction.factors.annualPremium : _this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
        }
        return _this;
    }
    OnlyEligibleEssentialsTierWidget.prototype.render = function () {
        var _a;
        var monthlyPremium = (_a = this.props.interaction.paymentDetails.instalmentPlan) === null || _a === void 0 ? void 0 : _a.monthlyPayment;
        var annualPremium = this.props.interaction.factors.annualPremium;
        var premiumToDisplay = this.getPremium(annualPremium, monthlyPremium);
        this.previousPremium = premiumToDisplay;
        var tierName = this.getSelectedTierName();
        var isNotPendingMta = this.props.interaction.status !== services_1.INTERACTION_STATUS_PENDING_MTA;
        return (React.createElement("div", { className: "tier-summary-container" },
            isNotPendingMta && React.createElement(AggregatorReferenceWidget_1.AggregatorReferenceWidget, { source: this.props.interaction.source }),
            React.createElement("div", { className: "tier-summary-widget w-100 essentials-tier-widget" },
                React.createElement("div", { className: "d-flex justify-content-between heading-row pb-4" },
                    React.createElement("img", { src: "/".concat(services_1.resourcesHelper.THEME, "/img/").concat(tierName, ".svg"), alt: "Tier logo" }),
                    React.createElement("h2", { className: "mt-3 tier-premium" },
                        (0, commonFunctions_1.getAmountToDisplay)(premiumToDisplay),
                        this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL
                            ? React.createElement("span", { className: "premium-type" }, "/ year*")
                            : React.createElement("span", { className: "premium-type" }, "/ month*"))),
                this.renderCarsDetails(),
                this.renderItems(items(this.props.interaction.optionalExtras, this.props.interaction.policyHolder.ncd.doNotDisclose)),
                React.createElement(FalconAccordion_1.FalconAccordion, { toggleHidden: React.createElement("div", { className: "toggle font-weight-semi-bold" }, "+ Show more cover details"), toggleShown: React.createElement("div", { className: "toggle font-weight-semi-bold" }, "- Show less cover details") }, this.renderItems(itemsUnderSpoiler)),
                this.renderPolicyDocumentSection())));
    };
    OnlyEligibleEssentialsTierWidget.prototype.getSelectedTierName = function () {
        switch (this.props.interaction.coverTier) {
            case services_1.MotorCoverTier.ALLIANZ_ESSENTIALS:
                return "allianz-essentials-tier";
            case services_1.MotorCoverTier.ALLIANZ_SILVER:
                return "allianz-silver-tier";
            case services_1.MotorCoverTier.ALLIANZ:
                return "allianz-tier";
            default:
                return "";
        }
    };
    OnlyEligibleEssentialsTierWidget.prototype.getPremium = function (annualPremium, monthlyPremium) {
        if (this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL) {
            return (annualPremium === 0) ? this.previousPremium : annualPremium;
        }
        else {
            return (monthlyPremium === 0) ? this.previousPremium : monthlyPremium;
        }
    };
    OnlyEligibleEssentialsTierWidget.prototype.renderItems = function (items) {
        return (React.createElement("div", { className: "list-container" }, items.map(function (item) { return (React.createElement("div", { key: item.text, className: "row flex-nowrap" },
            item.included
                ? React.createElement("img", { className: "mr-2 margin-top-0", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-green-tick.svg"), alt: "tick icon" })
                : React.createElement("img", { className: "mr-2 margin-top-0 multi-row cross-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/Flow-red-cross.svg"), alt: "tick icon" }),
            React.createElement("div", { className: "mt-1" }, item.text),
            item.info && (item.includeModal ? React.createElement("div", { className: "mt-1" }, item.info) :
                React.createElement(InfoModal_1.InfoModal, { className: "fixed-addon-info-icon mt-1", title: item.text }, item.info)))); })));
    };
    OnlyEligibleEssentialsTierWidget.prototype.renderCarsDetails = function () {
        var _this = this;
        var vehicles = this.props.interaction.vehicles;
        return vehicles.map(function (vehicle) { return (React.createElement("div", { key: vehicle.model, className: "mb-4" },
            React.createElement("div", { className: "font-weight-bold" }, "".concat(vehicle.make, ", ").concat(vehicle.model),
                " (",
                vehicle.registrationNumber,
                ")"),
            React.createElement("div", null, "".concat(_this.fetchLookupValue("carUsage", vehicle.classOfUse))))); });
    };
    OnlyEligibleEssentialsTierWidget.prototype.fetchLookupValue = function (fieldId, id) {
        var value = "";
        this.lookupService.fetchLookupValues(fieldId, "en-UK").subscribe(function (lookupValues) {
            var _a, _b;
            value = (_b = (_a = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.find(function (entry) { return entry.id === id; })) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        });
        return value;
    };
    OnlyEligibleEssentialsTierWidget.prototype.renderPolicyDocumentSection = function () {
        var premiumType = this.props.interaction.factors.premiumType;
        var documentVersion = (0, DocumentListModal_1.getDocumentVersionByDate)(new Date(this.props.interaction.factors.originalQuoteDate));
        return (React.createElement("div", { className: "margin-top-32 mb-5" },
            React.createElement("p", null,
                "Open the ",
                React.createElement("a", { target: "_blank", download: "Allianz Car Document of Insurance (DOI)", href: "/resources/documents/LV_Allianz_Annual_Car/".concat(documentVersion, "/LV_Allianz_Annual_Car_DOI_").concat(documentVersion, ".pdf") },
                    React.createElement("span", { className: "font-weight-semi-bold text-decoration-underline" }, "policy document")),
                " to see full cover details"),
            React.createElement("p", null,
                "* All figures include ",
                premiumType === services_1.PREMIUM_TYPE_ANNUAL ?
                    'Insurance Premium Tax' : 'Interest and Insurance Premium Tax')));
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], OnlyEligibleEssentialsTierWidget.prototype, "lookupService", void 0);
    return OnlyEligibleEssentialsTierWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=OnlyEligibleEssentialsTierWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/OnlyEligibleEssentialsTierWidget.js
// module id = 3241
// module chunks = 0